module.exports = "../../../../platform/assets/pageMainIcon/cd-number-amount.svg";